/*
TODO: remove this file if not used till 13th April 2023
*/
import { calculateTotalMeetingDuration } from "ui/pages/ZoomAttendance/ZoomAttendanceOfListing/ZoomAttendanceOfListing.helper";
import { _exporterBase } from "../_exporterBase";

const exporter_config = [
  {
    field: "customer_name",
    headerName: "Customer Name",
  },
  {
    field: "attendance",
    headerName: "Attendance",
    valueFormatter: (record) =>
      `${record.session_attended} / ${record.total_session}`,
  },
  {
    field: "total_meeting_duration",
    headerName: "Total Minutes Attended",
    valueFormatter: (record) =>
      calculateTotalMeetingDuration(record.total_meeting_duration).toString(),
  },
  {
    field: "customer_email",
    headerName: "Email",
  },
  {
    field: "customer_phone_numer",
    headerName: "Phone",
    valueFormatter: (record) =>
      record.customer_country_code + " " + record.customer_phone_numer,
  },
];

export const zoomAttendanceOfListingExporter = _exporterBase({
  responseMapFunction: (item) => {
    if (
      item.session_number !== undefined ||
      item.slot_uuid !== undefined ||
      item.total_unique_customers !== undefined
    ) {
      return {
        Session: `Session ${item.session_number ?? 1}`,
        Status: item.status
          ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
          : "N/A",
        "Booked Attendees": (item.total_unique_customers ?? 0).toString(),
        "Total Attendance %": `${Math.round(item.attendance_percentage ?? 0)}%`,
        "Full Attendance": (item.full_attendance ?? 0).toString(),
        "Partial Attendance": (item.partial_attendance ?? 0).toString(),
        Absent: (item.absent ?? 0).toString(),
        "Unrecognized Attendees": (item.unrecognized ?? 0).toString(),
      };
    }
    const obj = {};
    exporter_config.forEach((col) => {
      const val = col.valueFormatter
        ? col.valueFormatter(item)
        : item[col.field];
      obj[col.headerName] =
        val !== undefined && val !== null ? val.toString() : "0";
    });
    return obj;
  },
  downloadedCSVFileName: "zoom listing attendance",
});
